export default __webpack_public_path__ + "static/media/mission.80a611da.svg";